module.exports = __webpack_public_path__ + "img/tv.42095f3e.svg";